<div class="modal-header">
  <h5 class="modal-title">Create New Item for {{targetUserName}}</h5>
  <button type="button" class="btn btn-info cancel" (click)="activeModal.dismiss('cancel')"><i
      class="fas fa-times"></i></button>
</div>

<div class="modal-body">
  <form [formGroup]="observationForm" (ngSubmit)="onSubmit(observationForm)" errorTailor>
    <div class="p-1">
      <label class="form-label" for="observationType">Observation Type <span class="required">*</span></label>
      <select #observationType class="form-select" id="ObservationType" name="ObservationType"
        formControlName="ObservationType" (change)="onObservationTypeChange(observationType.value)">
        <option [defaultSelected]=true value=0 disabled>Select One</option>
        <option *ngFor="let opt of filteredOptions" [value]="opt.value">{{opt.label}}</option>
      </select>
    </div>

    <div *ngIf="shouldShowRubricTypePicker()" class="p-1">
      <label class="form-label" for="RubricDirectionType">Rubric Type<span class="required">*</span></label>
      <select class="form-select" id="RubricDirectionType" formControlName="RubricDirectionType">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let rubricDirectionType of rubricDirectionTypes" [ngValue]="rubricDirectionType.value">
          {{rubricDirectionType.label}}
        </option>
      </select>
    </div>

    <div *ngIf="shouldShowRolePicker()" class="p-1">
      <label class="form-label" for="UserRole">User Role <span class="required">*</span></label>
      <select class="form-select" id="UserRole" formControlName="UserRole">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let userRole of filteredTargetUserRoles" [ngValue]="userRole.ntpeLookupID ?? DEFAULT_USER_ROLE_ID">
          {{userRole.displayName}}
        </option>
      </select>
    </div>

    <div class="p-1">
      <label class="form-label" for="schoolYear">School Year <span class="required">*</span></label>
      <select class="form-select" id="schoolYear" formControlName="SchoolYear">
        <option [defaultSelected]=true value="" disabled>Select One</option>
        <option *ngFor="let opt of filteredSchoolYears" [value]="opt">{{opt}}</option>
      </select>
    </div>


    <div *ngIf="showRatingFormOptions()" class="p-1">
      <label class="form-label" for="SubType">Select Rating Type <span class="required">*</span></label>
      <select class="form-select" id="SubType" formControlName="SubType">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let formOpt of ratingFormOptions" [ngValue]="formOpt.value">{{formOpt.label}}</option>
      </select>
    </div>


    <div *ngIf="showAdditionalText()" class="p-1">
      <label class="form-label" for="AdditionalText">Message for Employee</label>
      <textarea formControlName="AdditionalText" rows="2" class="form-control" id="AdditionalText"></textarea>
    </div>

    <div *ngIf="showAdditionalOptionsSPM()" class="p-1">
      <label class="form-label" for="performanceMeasureType">Performance Measure Type <span class="required">*</span></label>
      <select class="form-select" id="performanceMeasureType" formControlName="PerformanceMeasureType" (change)="onObservationTypeChange(observationType.value)">
        <option [value]="null" disabled>Select One</option>
        <option *ngFor="let opt of filteredPerformanceMeasureTypes" [value]="opt.value">{{opt.label}}</option>
      </select>
    </div>

    <div *ngIf="showPresetOptions()" class="p-1">
        <div class="p-1">
            <label class="form-label" for="preset">Select Preset</label>
            <select class="form-select" id="preset" formControlName="Preset">
                <option [defaultSelected]=true [ngValue]="null">No Preset</option>
                <option *ngFor="let opt of filteredPresets" [value]="opt.presetID">{{opt.name}}</option>
            </select>
        </div>
    </div>


    <div *ngIf="showEvaluatorOptions()" class="p-1">
      <ng-template [ngIf]="shouldShowNoEvaluatorsAlert()">
        <div class="text-danger" role="alert" *permissionsAll="[PermissionTypes.CUSTOM_SUPERVISION_CAN_BE_TARGET]" >
          There are no evaluators available. Contact a portal administrator to update the assigned evaluator(s) in Custom Supervision Management.
        </div>
      </ng-template>
      <label class="form-label" for="evaluator">Select Evaluator <span class="required">*</span></label>
      <select class="form-select" id="evaluator" formControlName="Evaluator">
        <option [defaultSelected]=true [ngValue]="null" disabled>Select One</option>
        <option *ngFor="let opt of filteredEvaluators" [value]="opt.user.userID">{{opt.user.displayName}}</option>
      </select>
    </div>

    <div *ngIf="currentObservationType == '9'" class="custom-form-selector-container" class="p-1 mt-2" formGroupName="CustomFormSelector">
      <span class="edl-display-label">Select Custom Form <span class="required">*</span></span>
      <paetep-custom-form-selector-paging [targetUserId]="targetUserId">
      </paetep-custom-form-selector-paging>
    </div>

    <div class="text-end p-1">
      <button type="submit" class="btn btn-primary me-2"><i class="far fa-plus"></i> Create New Item</button>
      <button type="button" class="btn btn-info m-2" (click)="activeModal.close()">Cancel</button>
    </div>

  </form>
</div>
